import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import DataTable from "react-data-table-component";

function CrearAgendas() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [idItemEliminar, setIdItemEliminar] = useState();
    const [agendaResumenEliminar, setAgendaResumenEliminar] = useState(null);
    const [cargandoResumenEliminar, setCargandoResumenEliminar] = useState(false);
    const [eliminandoAgenda, setEliminandoAgenda] = useState(false);
    const [errorEliminar, setErrorEliminar] = useState('');
    const [modalContainerStatus,setModalContainerStatus] = useState('');
    const [modalBackdropStatus,setModalBackdropStatus] = useState('zindex-back');
    const isMountedRef = useRef(true);
    const timeoutBusquedaRef = useRef(null);

    const [terminoBusqueda, setTerminoBusqueda] = useState('');

    const [toastMsg, setToastMsg] = useState('');

    const getUserdata = () => {
        try {
            return JSON.parse(localStorage.getItem('userdata') || '{}');
        } catch (error) {
            return {};
        }
    };

    const cols = [
        { name:'Nombre', selector:row => row.nombre, sortable:true },
        { name:'Acción', cell:row => getBotones(row), minWidth: '20%' }
    ];

    const getBotones = (item) => {

        return (
            <>
            <Link to={'/editar-agenda?id='+item.id} className="btn btn-primary btn-sm"><i className="far fa-edit"></i>&nbsp;Editar</Link>&nbsp;
            <button
                type="button"
                onClick={() => showModal(item.id)}
                className="btn btn-outline-danger btn-sm"
            >
                <i className="fas fa-trash-alt"></i>&nbsp;Eliminar
            </button>
            </>
        )
    }

    useEffect(() => {
        isMountedRef.current = true;

        const userdata = getUserdata();
        const cargarCliente = async () => {
            if (!userdata.user_id) {
                if (isMountedRef.current) setLoggedIn(true);
                return;
            }

            try {
                const response = await axios.get('/get-client?uid=' + userdata.user_id);
                if (!isMountedRef.current) return;
                if (response.status === 200) {
                    setClient(response.data);
                }
            } catch (error) {
                console.log('err: ' + error);
            } finally {
                if (isMountedRef.current) {
                    // Permitir cargar pantalla incluso si /get-client responde 429 temporal
                    setLoggedIn(true);
                }
            }
        };

        cargarCliente();

        return () => {
            isMountedRef.current = false;
            if (timeoutBusquedaRef.current) {
                clearTimeout(timeoutBusquedaRef.current);
            }
        };
    },[]);


    const eliminar = async (id) => {
        if (!id || eliminandoAgenda) return;

        setEliminandoAgenda(true);
        setErrorEliminar('');

        try {
            const userdata = getUserdata();
            const response = await axios.delete('/crear-agenda', {
                params: {
                    id,
                    uid: userdata.user_id,
                },
            });

            if (response.status === 200 && response.data?.resultado) {
                const nombreItem =
                    response.data?.nombre ||
                    agendaResumenEliminar?.nombre ||
                    items.find((item) => String(item.id) === String(id))?.nombre ||
                    '';

                setItems((prevItems) => prevItems.filter((item) => String(item.id) !== String(id)));
                cerrar();
                setToastMsg(`La agenda ${nombreItem} ha sido eliminada`);
            } else {
                setErrorEliminar(response.data?.error || 'No se pudo eliminar la agenda.');
            }
        } catch (error) {
            const mensaje =
                error.response?.data?.error ||
                error.response?.data?.message ||
                'No se pudo eliminar la agenda. Verifique que tenga permisos e intente de nuevo.';
            setErrorEliminar(mensaje);
            console.error('Error al eliminar agenda:', error);
        } finally {
            setEliminandoAgenda(false);
        }
    };

    const showModal = async (id) => {
        setModalContainerStatus('show');
        setModalBackdropStatus('show');
        setIdItemEliminar(id);
        setAgendaResumenEliminar(null);
        setErrorEliminar('');
        setCargandoResumenEliminar(true);

        try {
            const response = await axios.get('/crear-agenda-citas-resumen', {
                params: { id },
            });
            if (isMountedRef.current) {
                setAgendaResumenEliminar(response.data);
            }
        } catch (error) {
            const item = items.find((row) => String(row.id) === String(id));
            if (isMountedRef.current) {
                setAgendaResumenEliminar({
                    id,
                    nombre: item?.nombre || 'Agenda',
                    total_citas: null,
                    total_citas_hoy_adelante: null,
                });
                setErrorEliminar(
                    'No se pudo cargar el resumen de citas. Puede continuar con la eliminación bajo su responsabilidad.'
                );
            }
        } finally {
            if (isMountedRef.current) {
                setCargandoResumenEliminar(false);
            }
        }
    };

    const cerrar = () => {
        setModalContainerStatus('');
        setModalBackdropStatus('zindex-back');
        setIdItemEliminar(null);
        setAgendaResumenEliminar(null);
        setErrorEliminar('');
        setCargandoResumenEliminar(false);
        setEliminandoAgenda(false);
    };


    useEffect(() => {
        if (!loggedIn) {
            return;
        }

        const userdata = getUserdata();
        if (!userdata.user_id) {
            return;
        }

        if (timeoutBusquedaRef.current) {
            clearTimeout(timeoutBusquedaRef.current);
        }

        timeoutBusquedaRef.current = setTimeout(() => {
            axios.get('/crear-agendas', {
                params: {
                    uid: userdata.user_id,
                    termino: terminoBusqueda
                }
            })
                .then(response => {
                    if (!isMountedRef.current) return;
                    setItems(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        }, 350);

        return () => {
            if (timeoutBusquedaRef.current) {
                clearTimeout(timeoutBusquedaRef.current);
            }
        };
    }, [terminoBusqueda, loggedIn]);


    if (loggedIn) {
        return (

            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                    <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/parametros-agenda">Parámetros de Agenda</Link></li>
                                        <li className="breadcrumb-item" key="bc4">Crear Agendas</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Crear Nueva Agenda</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">


                        <div className="row">
                            <div className="col-md-9">
                                <Link to="/nueva-agenda" className="btn btn-primary">Crear Nueva</Link>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label htmlFor="terminoBusqueda">Buscar</label>
                                    <input type="text" name="terminoBusqueda" className="form-control" id="terminoBusqueda" onChange={(e) => setTerminoBusqueda(e.target.value)} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">

                                <DataTable
                                columns={cols}
                                data={items}
                                pagination
                                paginationComponentOptions={{
                                    rowsPerPageText: 'Filas por página:',
                                    rangeSeparatorText: 'de',
                                    noRowsPerPage: false,
                                    selectAllRowsItem: true,
                                    selectAllRowsItemText: 'Todos'
                                }}
                                noDataComponent="No hay registros para mostrar"
                                id={'agendas'}
                                />

                            </div>
                        </div>

                        </div>
                    </section>
                </div>

                <div className={'modal-container modal fade in '+modalContainerStatus}>
                    <div className="modal-dialog">
                        <div className="modal-content">

                            <div className="modal-header bg-dark text-white">
                                <h4 className="modal-title text-white">Eliminar Agenda</h4>
                                <button type="button" className="close text-white" onClick={() => cerrar()}>&times;</button>
                            </div>

                            <div className="modal-body">
                                {cargandoResumenEliminar && (
                                    <p className="text-muted mb-0">
                                        <i className="fas fa-spinner fa-spin mr-2"></i>
                                        Consultando citas de la agenda...
                                    </p>
                                )}

                                {!cargandoResumenEliminar && agendaResumenEliminar && (
                                    <>
                                        <p className="mb-2">
                                            La agenda <strong>{agendaResumenEliminar.nombre}</strong> presenta:
                                        </p>
                                        <ul className="mb-3">
                                            <li>
                                                Total de citas:{' '}
                                                <strong>
                                                    {agendaResumenEliminar.total_citas ?? '—'}
                                                </strong>
                                            </li>
                                            <li>
                                                Total de citas de hoy en adelante:{' '}
                                                <strong>
                                                    {agendaResumenEliminar.total_citas_hoy_adelante ?? '—'}
                                                </strong>
                                            </li>
                                        </ul>
                                        <p className="mb-2">
                                            ¿Está seguro que desea eliminar esta agenda?
                                        </p>
                                        <p className="text-danger mb-0" style={{ fontSize: '0.9rem' }}>
                                            Si elimina la agenda, <strong>no se podrá recuperar</strong> las citas
                                            asociadas. Se eliminarán todas las citas de esta agenda y después la agenda.
                                        </p>
                                    </>
                                )}

                                {errorEliminar && (
                                    <div className="alert alert-warning mt-3 mb-0 py-2" style={{ fontSize: '0.9rem' }}>
                                        {errorEliminar}
                                    </div>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => cerrar()}
                                    disabled={eliminandoAgenda}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => eliminar(idItemEliminar)}
                                    disabled={eliminandoAgenda || cargandoResumenEliminar || !idItemEliminar}
                                >
                                    {eliminandoAgenda ? (
                                        <>
                                            <i className="fas fa-spinner fa-spin mr-1"></i>
                                            Eliminando...
                                        </>
                                    ) : (
                                        'Eliminar agenda y citas'
                                    )}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
                <div className={'modal-backdrop fade '+modalBackdropStatus}></div>

                <Footer showToast={false} delay={0} message={toastMsg} />
            </div>

        );
    }

    return (
        <Loading />
    );
}
export default CrearAgendas;
